import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../public/BigCLogo2022.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "E-Learning System", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "flex flex-center" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_img, {
        src: _imports_0,
        style: {"width":"100px","height":"100px"}
      }),
      _hoisted_1
    ]),
    _: 1
  }))
}